import { apis } from "../constants";
import { request } from "../utils";

export const getModuleAcrionMetadata = () => {
    return request<any>(apis.getMetadata, {method: 'get'})
}

export interface SearchSystemLogsParams {
    userId?: any,
    module?: any,
    action?: any,
    createTimeQueryEndDate?: string,
    createTimeQueryStartDate?: string,
    pageNum?: number,
    pageSize?: number,
}

export const searchSystemLogs = (params: Partial<SearchSystemLogsParams>) => {
    return request<PagedData<SystemLog>>(apis.queryOperationLog, {method: 'post', data: {
        ...params,
        currPage: params.pageNum
    }})
}